var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts"},[_c('div',{staticStyle:{"width":"320px","height":"120px"},attrs:{"id":'pieChart'+ _vm.ids}})])
}
var staticRenderFns = []

export { render, staticRenderFns }